import SectionCard from "@/components/SectionCard";
import BarChart from "@/components/charts/BarChart";

export default function PanelFugas({ transiciones, applyFilters }) {
  const sorted = [...transiciones]
    .filter((t) => t.perdidos != null)
    .sort((a, b) => b.perdidos - a.perdidos);

  return (
    <SectionCard
      title="Pérdida por transición"
      subtitle="Pacientes perdidos entre macro-etapas"
      testid="panel-fugas"
    >
      <BarChart
        horizontal
        categories={sorted.map((t) => `${t.desde} → ${t.hacia}`)}
        series={[{ name: "Perdidos", data: sorted.map((t) => applyFilters(t.perdidos)) }]}
        colors={["#F43F5E"]}
        height={200}
      />
    </SectionCard>
  );
}
